// core
import React from 'react';
import
{
    createBrowserRouter,
    RouterProvider
} from "react-router-dom";

import SiteRoot from 'pages/master';
// route conf
import conf from 'conf/config';

// components
import AjaxSpinner from 'components/commons/ajax_spinner';
import NotFound from 'components/commons/404';

// pages
import LoginPage from 'pages/login_page';
import LogoutPage from 'pages/logout_page';
import InfoPage from 'pages/info_page';
import ForgotPasswordPage from 'pages/forgot_password_page';
import ResetPasswordPage from 'pages/reset_password_page'
import RegisterPage from 'pages/registration_page';
import ImpersonatePage from 'pages/impersonate_page';

// status
import { useContext } from 'react';
import { UserContext } from 'store/user_context';

export default function Main(props)
{
    const user_data = useContext(UserContext);
    const router = createBrowserRouter([
        {
            path: conf.route.base,
            element: <SiteRoot />,
            errorElement: <NotFound />,
            children: [
                {
                    path: `${conf.route.base}/`,
                    element: <LoginPage user={user_data} set_user_data={props.set_user_data}/>
                },
                {
                    path: conf.route.userinfo,
                    element: <InfoPage user={user_data}/>
                },
                {
                    path: conf.route.logout,
                    element: <LogoutPage user={user_data} set_user_data={props.set_user_data}/>
                },
                {
                    path: conf.route.login,
                    element: <LoginPage user={user_data} set_user_data={props.set_user_data}/>
                },
                {
                    path: conf.route.forgot_password,
                    element: <ForgotPasswordPage user={user_data}/>
                },
                {
                    path: conf.route.reset_password,
                    element: <ResetPasswordPage user={user_data} set_user_data={props.set_user_data} />
                },
                {
                    path: conf.route.register,
                    element: <RegisterPage user={user_data}/>
                },
                {
                    path: conf.route.impersonate,
                    element: <ImpersonatePage user={user_data} set_user_data={props.set_user_data}/>
                },
                {
                    path: '*',
                    element: <NotFound />
                }
            ]
        }
    ]);
    return (
        <>
        <div id="top-wrapper">
            <div id="top-inner-wrapper">
            <header>
                <h1>
                    <a href={conf.server.default_redirect_after_login}>
                        Wolters Kluwer<br />CCH<sup>&reg;</sup> Tagetik Community
                    </a>
                </h1>
            </header>
            <main>
                <RouterProvider router={router}
                    errorElement={<NotFound/>}
                    fallbackElement={<AjaxSpinner />}
                />
            </main>
            </div>
        </div>
        <div id="bottom-wrapper">
        <footer>
            <div>
                <p>
                    <span>If you need assistance, please send an email to <a href="mailto:tgk-dl-community@wolterskluwer.com">tgk-dl-community@wolterskluwer.com</a></span>
                </p>
                <p>&copy; 2026 Tagetik Software srl VAT/P.IVA N° 01234830469</p>
            </div>
            <div>
                <a href="https://www.trustradius.com/welcome/tagetik" className='trustradius' target="_blank">Review us on TrustRadius</a>
            </div>

        </footer>
        </div>
        </>
    );
};
